module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="dropdown email-btn-wrapper email-btn">\n    <a href="#" class="dropdown-toggle copy btn email-btn" data-toggle="dropdown">Copy Email Code&nbsp;<span class="caret"></span></a>\n\n    <ul class="dropdown-menu more-dropdown-menu">\n        <li><a class="menu-item email-btn-default">Default</a></li>\n        <li><a class="menu-item email-btn-ometria">Ometria</a></li>\n        <li><a class="menu-item email-btn-klaviyo">Klaviyo</a></li>\n        <li><a class="menu-item email-btn-sfmc">SFMC</a></li>\n    </ul>\n</div>\n<div class="email-client-popup"></div>';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/editor/email/CopyEmailButtonView.tpl
// module id = 2939
// module chunks = 0